import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAgencyUser } from 'redux/selectors';
import { reinviteAgencyUser } from 'services';
import { useCreateDispatches } from 'helpers/hooks';
import { errors } from 'helpers';
import { StaticTextRow, EmailStaticTextRow, SectionHeader } from 'components';
import styles from '../managers.module.css';

export default function ManagerBasicInfo() {
	const { managerId } = useParams();
	const { firstname, lastname, email, status } = useSelector(
		getAgencyUser(managerId)
	);
	const { setLoader, setSnackbar, setSnackbarError } = useCreateDispatches();

	const onResendInvite = async () => {
		setLoader(true);
		await reinviteAgencyUser(managerId)
			.then((res) => {
				setSnackbar({
					variant: 'success',
					message: 'Invite successfully re-sent.',
				});
			})
			.catch((err) => {
				setSnackbarError(
					{ response: err.response, ...errors.USER_REINVITE('Manager') },
					{ log: true }
				);
			})
			.finally(() => {
				setLoader(false);
			});
	};

	const inputs = [
		{ label: 'First Name', value: firstname },
		{ label: 'Last Name', value: lastname },
	];
	const inputMap = inputs?.map((val) => {
		return val.value ? (
			<StaticTextRow key={val.label} variant='outlined' {...val} />
		) : null;
	});

	return (
		<>
			<SectionHeader>Manager Information</SectionHeader>
			<div className={styles.managerBasicInfoRoot}>
				{inputMap}
				<EmailStaticTextRow
					value={email}
					status={status}
					onResend={onResendInvite}
				/>
			</div>
		</>
	);
}
